// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__cNC13","title":"Info_title__WTewR","links":"Info_links__2fDuo","link":"Info_link__1c58a","logo":"Info_logo__t91pa"};